import { format, subDays } from "date-fns";
import { api } from "../../config";
import { toast } from "react-toastify";

export const updateDatabaseTickets = async (
  token: string,
  type: "checklist" | "measuring" | "assemble"
) => {
  try {
    await api(token).post(`tickets/${type}/fetch-external`, {
      date: format(subDays(new Date(), 30), "yyyyMMdd"),
    });
  } catch (error: any) {
    toast.error(
      error.response?.data?.error ??
        "Ocorreu um erro ao recuperar os tickets, por favor tente novamente mais tarde"
    );
    throw error;
  }
};

export const formatCurrency = (value: number) => {
  const stringValue = value.toFixed(2).replace(/\D+/, "");

  if (stringValue.length > 8) {
    return stringValue.replace(
      /(\d{1,3})(\d{3})(\d{3})(\d{2})/g,
      "R$ $1.$2.$3,$4"
    );
  } else if (stringValue.length > 5) {
    return stringValue.replace(/(\d{1,3})(\d{3})(\d{2})/g, "R$ $1.$2,$3");
  } else {
    return stringValue.replace(/(\d{1,3})(\d{2})/g, "R$ $1,$2");
  }
};

export const importExternalTicketByExternalId = async (
  token: string,
  externalId: string,
  type: "checklist" | "measuring" | "assemble",
  handleClose: () => void
) => {
  try {
    const importedTickets = await api(token).get(
      `/tickets/${type}/import-external/${externalId}`
    );
    toast.success("Ticket importado com sucesso!");
    handleClose();
    return importedTickets;
  } catch (error: any) {
    toast.error(error.response?.data?.error);
  }
};

export const duplicateFieldReportTicket = async (
  fieldReportId: number,
  token: string
) => {
  try {
    await api(token).post(`/tickets/measuring/duplicate/${fieldReportId}`, {});
    toast.success("Ticket duplicado com sucesso!");
  } catch (error: any) {
    toast.error(error.response?.data?.error);
  }
};

export const formatTicketStatus = (status: string) => {
  switch (status) {
    case "ASSEMBLE_PENDING_SCHEDULE":
      return "PENDENTE AGENDAMENTO";
    case "ASSEMBLE_PENDING":
      return "AGUARDANDO MONTAGEM";
    case "ASSEMBLE_WAITING_ANALYSIS":
      return "AGUARDANDO ANÁLISE";
    case "ASSEMBLE_REJECTED":
      return "REJEITADOS";
    case "ASSEMBLE_WAITING_PARTS":
      return "AGUARDANDO PEÇA";
    case "ASSEMBLE_TECHNICAL_ASSISTANCE":
      return "ASSISTÊNCIA TÉCNICA";
    case "ASSEMBLE_APPROVED":
      return "AGUARDANDO PAGAMENTO";
    case "ASSEMBLE_FINALIZED":
      return "FINALIZADOS";
    case "ASSEMBLE_CANCELLED":
      return "CANCELADOS";
    default:
      return "Sem status";
  }
};

export const formatTicketStatusNumber = (status: number) => {
  switch (status) {
    case 1:
      return "PENDENTE AGENDAMENTO";
    case 2:
      return "AGUARDANDO MONTAGEM";
    case 3:
      return "AGUARDANDO ANÁLISE";
    case 4:
      return "REJEITADOS";
    case 5:
      return "AGUARDANDO PEÇA";
    case 6:
      return "ASSISTÊNCIA TÉCNICA";
    case 7:
      return "AGUARDANDO PAGAMENTO";
    case 8:
      return "FINALIZADOS";
    case 9:
      return "CANCELADOS";

    default:
      return "Sem status";
  }
};

export const getProductsSeniority = (products: any[]) => {
  const newProducts = products?.reduce((acc: any, product: any) => {
    if (acc > product.product?.seniorityId) {
      acc = product.product.seniorityId;
    }
    return acc;
  }, Infinity);
  return newProducts === Infinity ? null : newProducts;
};

export const getProductsAssembleTime = (products: any[]) => {
  const newProducts = products.reduce((acc: any, product: any) => {
    if (product.product?.assemblyTime) {
      acc += product.product.assemblyTime;
    }
    if (product.assemblyTime) {
      acc += product.assemblyTime;
    }
    return acc;
  }, 0);
  return newProducts;
};

export const formatSeniority = (seniorityId: number) => {
  switch (seniorityId) {
    case 1:
      return "Senior";
    case 2:
      return "Pleno";
    case 3:
      return "Junior";
    default:
      return "Sem Senioridade";
  }
};

export const createSingleTicket = async (token: string, payload: any) => {
  try {
    const response = await api(token).post("ticket/assemble/single", payload);
    return response
  } catch (error: any) {
    toast.error(error.response?.data?.error);
  }
};

export const createSingleAssistTecTicket = async (token: string, payload: any) => {
    const response = await api(token).post("ticket/assemble/single-assist-tec", payload);
    return response
};

export const saleStatusDict = (status: number) => {
  let response = ''
  switch (status){ 
  case 2:
    response = 'Efetivada'
    break;
  case 7:
    response = 'Promissória'
    break;
  }
  return response
}
